const useMobileAppStyles: Function = (): MaterialUIStyles => ({
  'body': {
    margin: 'env(safe-area-inset-top) env(safe-area-inset-right) '
      + 'env(safe-area-inset-bottom) env(safe-area-inset-left) !important',
  },
  'header': {
    height: 'calc(64px + env(safe-area-inset-top)) !important',
    paddingTop: 'env(safe-area-inset-top) !important',
  },
  '.modal-layout': {
    paddingTop: 'env(safe-area-inset-top) !important',
  },
  '.modal-drawer-paper': {
    paddingTop: 'env(safe-area-inset-top) !important',
  },
});

export default useMobileAppStyles;
